<template>

  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-btn slot="activator" color="primary" dark>Slide-in Profile</v-btn>
      <v-card color="grey darken-4">

        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-form @submit="testSearch">
            <v-text-field 
              v-model="speciesSearch"
              hide-details
              prepend-inner-icon="mdi mdi-magnify"
              single-line color="accent"
              solo
              label="Search by species..."
              autofocus
              clearable
            ></v-text-field>
          </v-form>
        </v-toolbar>

        <v-container fluid>
            <fish-card :Species="searchTerm"></fish-card>
        </v-container>

      </v-card>
    </v-dialog>
  </v-layout>

</template>

<script>
import FishCard from './fishCard.vue'

export default {
  data () {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      speciesSearch: '',
      searchTerm: ''
    }
  },
  components: {'fish-card': FishCard},
  methods: {
    testSearch: function () {
      console.log(this.speciesSearch)
      this.searchTerm = this.speciesSearch
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/layouts/sandbox/examples/fishProfile.vue